import React, { useState, useEffect, useRef } from 'react';
import FormSection from '../FormSection';
import FormField from '../FormField';
import Input from '../Input';
import SearchableSelect from '../SearchableSelect';
import PhoneInput from '../PhoneInput';
import MultiSelectTags from '../MultiSelectTags';
import { ContactInfo, BasicInstitutionalInfo, ThematicAxis, SocialNetworks } from '../../types/profile.types';
import { areas, subareasPorArea, tiposOrganizacion, thematicAxes, subejesPorEje } from '../../data/profileData';
import './ThematicAxesSection.css';
import './ContactInfoSection.css';

// Países con dialCode y flag (igual que PhoneInput)
const countries = [
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽' },
  { code: 'PE', name: 'Perú', dialCode: '+51', flag: '🇵🇪' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'PA', name: 'Panamá', dialCode: '+507', flag: '🇵🇦' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹' },
  { code: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻' },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505', flag: '🇳🇮' },
  { code: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  { code: 'DO', name: 'República Dominicana', dialCode: '+1', flag: '🇩🇴' },
  { code: 'HT', name: 'Haití', dialCode: '+509', flag: '🇭🇹' },
  { code: 'JM', name: 'Jamaica', dialCode: '+1', flag: '🇯🇲' },
  { code: 'TT', name: 'Trinidad y Tobago', dialCode: '+1', flag: '🇹🇹' },
  { code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦' },
  { code: 'ES', name: 'España', dialCode: '+34', flag: '🇪🇸' },
  { code: 'IT', name: 'Italia', dialCode: '+39', flag: '🇮🇹' },
  { code: 'FR', name: 'Francia', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemania', dialCode: '+49', flag: '🇩🇪' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'NL', name: 'Países Bajos', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32', flag: '🇧🇪' },
  { code: 'CH', name: 'Suiza', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'SE', name: 'Suecia', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlandia', dialCode: '+358', flag: '🇫🇮' },
  { code: 'PL', name: 'Polonia', dialCode: '+48', flag: '🇵🇱' },
  { code: 'CZ', name: 'República Checa', dialCode: '+420', flag: '🇨🇿' },
  { code: 'HU', name: 'Hungría', dialCode: '+36', flag: '🇭🇺' },
  { code: 'RO', name: 'Rumania', dialCode: '+40', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬' },
  { code: 'GR', name: 'Grecia', dialCode: '+30', flag: '🇬🇷' },
  { code: 'RU', name: 'Rusia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'UA', name: 'Ucrania', dialCode: '+380', flag: '🇺🇦' },
  { code: 'IE', name: 'Irlanda', dialCode: '+353', flag: '🇮🇪' },
  { code: 'IS', name: 'Islandia', dialCode: '+354', flag: '🇮🇸' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'JP', name: 'Japón', dialCode: '+81', flag: '🇯🇵' },
  { code: 'KR', name: 'Corea del Sur', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'TH', name: 'Tailandia', dialCode: '+66', flag: '🇹🇭' },
  { code: 'SG', name: 'Singapur', dialCode: '+65', flag: '🇸🇬' },
  { code: 'MY', name: 'Malasia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'PH', name: 'Filipinas', dialCode: '+63', flag: '🇵🇭' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'TW', name: 'Taiwán', dialCode: '+886', flag: '🇹🇼' },
  { code: 'HK', name: 'Hong Kong', dialCode: '+852', flag: '🇭🇰' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'PK', name: 'Pakistán', dialCode: '+92', flag: '🇵🇰' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'NP', name: 'Nepal', dialCode: '+977', flag: '🇳🇵' },
  { code: 'MM', name: 'Myanmar', dialCode: '+95', flag: '🇲🇲' },
  { code: 'KH', name: 'Camboya', dialCode: '+855', flag: '🇰🇭' },
  { code: 'LA', name: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  { code: 'MN', name: 'Mongolia', dialCode: '+976', flag: '🇲🇳' },
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nueva Zelanda', dialCode: '+64', flag: '🇳🇿' },
  { code: 'FJ', name: 'Fiyi', dialCode: '+679', flag: '🇫🇯' },
  { code: 'PG', name: 'Papúa Nueva Guinea', dialCode: '+675', flag: '🇵🇬' },
  { code: 'NC', name: 'Nueva Caledonia', dialCode: '+687', flag: '🇳🇨' },
  { code: 'ZA', name: 'Sudáfrica', dialCode: '+27', flag: '🇿🇦' },
  { code: 'EG', name: 'Egipto', dialCode: '+20', flag: '🇪🇬' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'KE', name: 'Kenia', dialCode: '+254', flag: '🇰🇪' },
  { code: 'MA', name: 'Marruecos', dialCode: '+212', flag: '🇲🇦' },
  { code: 'TN', name: 'Túnez', dialCode: '+216', flag: '🇹🇳' },
  { code: 'DZ', name: 'Argelia', dialCode: '+213', flag: '🇩🇿' },
  { code: 'GH', name: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'ET', name: 'Etiopía', dialCode: '+251', flag: '🇪🇹' },
  { code: 'UG', name: 'Uganda', dialCode: '+256', flag: '🇺🇬' },
  { code: 'TZ', name: 'Tanzania', dialCode: '+255', flag: '🇹🇿' },
  { code: 'ZW', name: 'Zimbabue', dialCode: '+263', flag: '🇿🇼' },
  { code: 'BW', name: 'Botsuana', dialCode: '+267', flag: '🇧🇼' },
  { code: 'NA', name: 'Namibia', dialCode: '+264', flag: '🇳🇦' },
  { code: 'ZM', name: 'Zambia', dialCode: '+260', flag: '🇿🇲' },
  { code: 'MW', name: 'Malaui', dialCode: '+265', flag: '🇲🇼' },
  { code: 'MZ', name: 'Mozambique', dialCode: '+258', flag: '🇲🇿' },
  { code: 'MG', name: 'Madagascar', dialCode: '+261', flag: '🇲🇬' },
  { code: 'MU', name: 'Mauricio', dialCode: '+230', flag: '🇲🇺' },
  { code: 'SC', name: 'Seychelles', dialCode: '+248', flag: '🇸🇨' },
  { code: 'SA', name: 'Arabia Saudí', dialCode: '+966', flag: '🇸🇦' },
  { code: 'AE', name: 'Emiratos Árabes Unidos', dialCode: '+971', flag: '🇦🇪' },
  { code: 'QA', name: 'Catar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'KW', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'BH', name: 'Baréin', dialCode: '+973', flag: '🇧🇭' },
  { code: 'OM', name: 'Omán', dialCode: '+968', flag: '🇴🇲' },
  { code: 'JO', name: 'Jordania', dialCode: '+962', flag: '🇯🇴' },
  { code: 'LB', name: 'Líbano', dialCode: '+961', flag: '🇱🇧' },
  { code: 'SY', name: 'Siria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'IQ', name: 'Irak', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IR', name: 'Irán', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'TR', name: 'Turquía', dialCode: '+90', flag: '🇹🇷' }
];

// Función helper para parsear el teléfono guardado
const parsePhone = (phone: string): { codigoPais: string; numeroTelefono: string } => {
  if (!phone || !phone.trim()) {
    return { codigoPais: 'AR', numeroTelefono: '' };
  }

  // Buscar el código de país que coincida al inicio del teléfono
  for (const country of countries) {
    if (phone.trim().startsWith(country.dialCode)) {
      const numeroTelefono = phone.replace(country.dialCode, '').trim();
      return { codigoPais: country.code, numeroTelefono };
    }
  }

  // Si no se encuentra, asumir Argentina por defecto
  return { codigoPais: 'AR', numeroTelefono: phone.trim() };
};

interface ContactInfoSectionProps {
  readOnly?: boolean;
  data: ContactInfo;
  onChange: (data: ContactInfo) => void;
  basicInfo?: BasicInstitutionalInfo;
  onBasicInfoChange?: (data: BasicInstitutionalInfo) => void;
  errors?: Record<string, string>;
  basicInfoErrors?: Record<string, string>;
  axesError?: string;
  userEmail?: string; // Email del usuario autenticado (no modificable)
  /** En móvil/tablet: notifica cuando la barra de checkboxes fijos entra/sale del viewport para ajustar el widget */
  onCheckboxBarVisible?: (visible: boolean) => void;
  /** Cuando true, la sección se usa en el modal "Crear contacto" del CRM; los cambios solo aplican aquí y no en el perfil privado */
  createContactMode?: boolean;
}

// Función para capitalizar solo la primera letra (mantener el resto como está, incluyendo espacios)
const capitalizeFirstLetter = (str: string): string => {
  if (!str) return '';
  // Encontrar el primer carácter que no sea espacio
  const firstNonSpaceIndex = str.search(/\S/);
  if (firstNonSpaceIndex === -1) {
    // Si solo hay espacios, retornar como está
    return str;
  }
  // Capitalizar solo la primera letra no-espacio, mantener todo lo demás (incluyendo espacios)
  return str.slice(0, firstNonSpaceIndex) + 
         str.charAt(firstNonSpaceIndex).toUpperCase() + 
         str.slice(firstNonSpaceIndex + 1);
};

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  readOnly = false,
  data,
  onChange,
  basicInfo,
  onCheckboxBarVisible,
  onBasicInfoChange,
  errors, 
  basicInfoErrors,
  axesError,
  userEmail,
  createContactMode = false
}) => {
  // Estado para redes sociales (no se usa actualmente pero se mantiene para futuras implementaciones)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [socialNetworks, setSocialNetworks] = useState<SocialNetworks>(basicInfo?.socialNetworks || {});
  const [websiteError, setWebsiteError] = useState<string>('');
  
  // Estados locales para errores de validación en tiempo real
  const [localEmailError, setLocalEmailError] = useState<string>('');
  const [localPhoneError, setLocalPhoneError] = useState<string>('');
  
  const [visibleTooltip, setVisibleTooltip] = React.useState<number | null>(null);
  const [tooltipPosition, setTooltipPosition] = React.useState<{ left: number; top: number } | null>(null);
  const tooltipRef = React.useRef<HTMLDivElement | null>(null);
  const [isMobileOrTablet, setIsMobileOrTablet] = React.useState(false);
  const checkboxBarSentinelRef = useRef<HTMLDivElement | null>(null);

  // En móvil/tablet: notificar cuando la barra de checkboxes entra/sale del viewport para que el widget ajuste posición
  useEffect(() => {
    if (!onCheckboxBarVisible || !checkboxBarSentinelRef.current) return;
    const el = checkboxBarSentinelRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          onCheckboxBarVisible(entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [onCheckboxBarVisible]);

  // Obtener subáreas dinámicas basadas en el área seleccionada
  const getSubareasDinamicas = () => {
    if (!data.area) {
      return [];
    }
    return subareasPorArea[data.area as keyof typeof subareasPorArea]?.subareas || [];
  };

  const subareasDinamicas = getSubareasDinamicas();

  // Detectar si es mobile o tablet para tooltips
  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


  // Función de validación de URL (igual al form participar)
  const validateUrl = (url: string): boolean => {
    if (url.trim() === '') return true; // Campo opcional

    // Si ya tiene protocolo, validar URL completa
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const urlRegex = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
      return urlRegex.test(url);
    }

    // Si no tiene protocolo, validar solo dominio
    const domainRegex = /^(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
    return domainRegex.test(url);
  };

  const handleBasicInfoChange = (field: keyof BasicInstitutionalInfo, value: any) => {
    if (onBasicInfoChange && basicInfo) {
      onBasicInfoChange({ ...basicInfo, [field]: value });
    }
  };

  const handleBasicInfoBlur = (field: keyof BasicInstitutionalInfo, value: string) => {
    // Capitalizar primera letra solo cuando el usuario termina de escribir (onBlur)
    if (field === 'organizationName') {
      const capitalized = capitalizeFirstLetter(value);
      if (capitalized !== value && onBasicInfoChange && basicInfo) {
        onBasicInfoChange({ ...basicInfo, [field]: capitalized });
      }
    }
  };

  const handleWebsiteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    handleBasicInfoChange('website', value);
  };

  // Validar website continuamente para que el error persista mientras haya contenido inválido
  useEffect(() => {
    const website = basicInfo?.website || '';
    if (website.trim() === '') {
      setWebsiteError('');
    } else if (!validateUrl(website)) {
      setWebsiteError('Por favor, ingresa una URL válida');
    } else {
      setWebsiteError('');
    }
  }, [basicInfo?.website]);

  const handleWebsiteBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();

    // Si el usuario escribió algo y no tiene protocolo, agregar https://
    if (value && !value.startsWith('http://') && !value.startsWith('https://')) {
      // Verificar si parece un dominio válido
      const domainRegex = /^(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
      if (domainRegex.test(value)) {
        handleBasicInfoChange('website', `https://${value}`);
      }
    }
  };

  // Función para cambiar redes sociales (no se usa actualmente pero se mantiene para futuras implementaciones)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSocialNetworkChange = (network: keyof SocialNetworks, value: string) => {
    // Esta función no se usa actualmente
    // Se mantiene para referencia futura
    return;
  };

  // Efecto para manejar el tooltip de ejes temáticos
  React.useEffect(() => {
    if (tooltipRef.current && tooltipRef.current.parentNode) {
      tooltipRef.current.parentNode.removeChild(tooltipRef.current);
      tooltipRef.current = null;
    }

    if (visibleTooltip !== null && tooltipPosition !== null) {
      const ejeSeleccionado = thematicAxes[visibleTooltip];
      const subejes = subejesPorEje[ejeSeleccionado.label]?.subejes || [];

      if (subejes.length === 0) return;

      // Detectar si está en modo oscuro
      const isDarkMode = document.documentElement.classList.contains('dark-theme');

      const tooltipDiv = document.createElement('div');
      tooltipDiv.className = 'tooltip-content';
      tooltipDiv.style.cssText = `
        position: fixed !important;
        left: ${tooltipPosition.left}px !important;
        top: ${tooltipPosition.top}px !important;
        z-index: 999999 !important;
        background-color: ${isDarkMode ? '#0f172a' : '#ffffff'} !important;
        border: 2px solid #CE2B15 !important;
        border-radius: 8px !important;
        padding: 12px 16px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        min-width: 280px !important;
        max-width: 400px !important;
        font-family: Montserrat, sans-serif !important;
        pointer-events: none !important;
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
      `;

      const titleDiv = document.createElement('div');
      titleDiv.style.cssText = `font-weight: 700; color: ${isDarkMode ? '#ffffff' : '#1e293b'}; font-size: 13px; margin-bottom: 8px; padding-bottom: 6px; border-bottom: 1px solid ${isDarkMode ? '#334155' : '#e5e7eb'};`;
      titleDiv.textContent = 'Incluye:';

      const ul = document.createElement('ul');
      ul.style.cssText = 'list-style: none; padding: 0; margin: 0;';

      subejes.forEach((subeje) => {
        const li = document.createElement('li');
        li.style.cssText = `font-size: 12px; color: ${isDarkMode ? '#cbd5e1' : '#64748b'}; line-height: 1.6; padding: 4px 0; padding-left: 16px; position: relative;`;

        const bullet = document.createElement('span');
        bullet.style.cssText = 'position: absolute; left: 0; color: #CE2B15; font-weight: bold;';
        bullet.textContent = '•';

        li.appendChild(bullet);
        li.appendChild(document.createTextNode(subeje));
        ul.appendChild(li);
      });

      tooltipDiv.appendChild(titleDiv);
      tooltipDiv.appendChild(ul);

      if (document.body) {
        document.body.appendChild(tooltipDiv);
        tooltipRef.current = tooltipDiv;
      }

      return () => {
        if (tooltipRef.current && tooltipRef.current.parentNode) {
          tooltipRef.current.parentNode.removeChild(tooltipRef.current);
          tooltipRef.current = null;
        }
      };
    }
  }, [visibleTooltip, tooltipPosition]);

  const handleAxesChange = (value: ThematicAxis, checked: boolean) => {
    const currentAxes = data.thematicAxes || [];
    const newAxes = checked 
      ? [...currentAxes, value]
      : currentAxes.filter(v => v !== value);
    onChange({ ...data, thematicAxes: newAxes });
  };

  const handleChange = (field: keyof ContactInfo, value: string) => {
    // No permitir cambiar el email si viene del usuario autenticado
    if (field === 'email' && userEmail) {
      return;
    }

    // Para nombre, apellido y cargo, permitir escribir normalmente (con espacios)
    // La capitalización se hará al perder el foco (onBlur)
    onChange({ ...data, [field]: value });
  };

  const handleBlur = (field: keyof ContactInfo, value: string) => {
    // Capitalizar primera letra solo cuando el usuario termina de escribir (onBlur)
    if (field === 'firstName' || field === 'lastName' || field === 'position') {
      const capitalized = capitalizeFirstLetter(value);
      if (capitalized !== value) {
        onChange({ ...data, [field]: capitalized });
      }
    }
  };

  // Función para manejar cambios en el área
  const handleAreaChange = (value: string) => {
    // Limpiar subárea si el área cambió
    const areaCambio = data.area !== value;
    onChange({
      ...data,
      area: value,
      subarea: areaCambio ? '' : data.subarea
    });
  };

  const handleCodigoPaisChange = (codigo: string) => {
    // Actualizar código de país y combinar con número de teléfono
    const selectedCountry = countries.find(c => c.code === codigo);
    const dialCode = selectedCountry?.dialCode || '';
    const phone = `${dialCode} ${data.numeroTelefono || ''}`.trim();
    onChange({
      ...data,
      codigoPais: codigo,
      phone: phone
    });
  };

  const handleNumeroTelefonoChange = (numero: string) => {
    // Actualizar número de teléfono y combinar con código de país
    // Mantener espacios en el número de teléfono (no usar trim en el número)
    const selectedCountry = countries.find(c => c.code === (data.codigoPais || 'AR')) || countries[0];
    const dialCode = selectedCountry?.dialCode || '';
    // Solo hacer trim del espacio entre código y número, pero mantener espacios dentro del número
    const phone = numero.trim() ? `${dialCode} ${numero.trim()}` : dialCode;
    onChange({
      ...data,
      numeroTelefono: numero, // Mantener el número tal como viene (con espacios si los tiene)
      phone: phone
    });
  };

  // Usar el email del usuario autenticado si existe
  const displayEmail = userEmail || data.email;

  return (
    <div className="contact-info-section-container">
    <FormSection 
      title={createContactMode ? undefined : 'Información Personal'} 
      required={!createContactMode}
    >
      {/* Sentinel al inicio: en móvil/tablet al entrar en viewport (al pasar las pestañas) se ajusta el widget */}
      <div ref={checkboxBarSentinelRef} aria-hidden="true" style={{ height: 1, marginBottom: -1 }} />
      {/* Fila 1: Nombre - Apellido */}
      <div className="form-row">
        <FormField label="Nombre" required={!createContactMode} error={errors?.firstName}>
          <Input
            value={data.firstName || ''}
            onChange={(e) => handleChange('firstName', e.target.value)}
            onBlur={(e) => handleBlur('firstName', e.target.value)}
            placeholder="Nombre"
            error={!!errors?.firstName}
            disabled={readOnly}
          />
        </FormField>
        <FormField label="Apellido" required={!createContactMode} error={errors?.lastName}>
          <Input
            value={data.lastName || ''}
            onChange={(e) => handleChange('lastName', e.target.value)}
            onBlur={(e) => handleBlur('lastName', e.target.value)}
            placeholder="Apellido"
            error={!!errors?.lastName}
            disabled={readOnly}
          />
        </FormField>
      </div>

      {/* Fila 2: Correo - Teléfono */}
      <div className="form-row" id="create-contact-email">
        <FormField label="Correo electrónico" required error={errors?.email || localEmailError}>
          <Input
            type="email"
            value={displayEmail}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="correo@ejemplo.com"
            error={!!errors?.email || !!localEmailError}
            disabled={readOnly || !!userEmail}
            title={userEmail ? 'El correo electrónico no puede modificarse' : ''}
          />
          {userEmail && (
            <p style={{ 
              fontSize: '12px', 
              color: '#64748b', 
              marginTop: '4px',
              fontStyle: 'italic',
              fontFamily: "'Montserrat', sans-serif"
            }}>
              Este correo está asociado a tu cuenta y no puede modificarse
            </p>
          )}
        </FormField>
        <FormField label="Teléfono" required={!createContactMode} error={errors?.phone || localPhoneError}>
          <PhoneInput
            codigoPais={data.codigoPais || parsePhone(data.phone || '').codigoPais}
            numeroTelefono={data.numeroTelefono || parsePhone(data.phone || '').numeroTelefono}
            onCodigoPaisChange={handleCodigoPaisChange}
            onNumeroTelefonoChange={handleNumeroTelefonoChange}
            error={errors?.phone || localPhoneError}
            disabled={readOnly}
          />
        </FormField>
      </div>

      {/* Fila 3: Organización (1 columna de 2) - Tipo de org - oculto en modal crear contacto */}
      {!createContactMode && (
      <div className="form-row">
        <FormField label="Organización" required error={basicInfoErrors?.organizationName}>
          <Input
            value={basicInfo?.organizationName || ''}
            onChange={(e) => handleBasicInfoChange('organizationName', e.target.value)}
            onBlur={(e) => handleBasicInfoBlur('organizationName', e.target.value)}
            placeholder="Ingresa el nombre de tu organización"
            error={!!basicInfoErrors?.organizationName}
            disabled={readOnly}
          />
        </FormField>
        <FormField label="Tipo de organización" required error={basicInfoErrors?.organizationType}>
          <SearchableSelect
            value={basicInfo?.organizationType || ''}
            onChange={(value) => handleBasicInfoChange('organizationType', value)}
            options={tiposOrganizacion}
            placeholder="Seleccionar tipo de organización..."
            allowCustomInput={false}
            error={!!basicInfoErrors?.organizationType}
            disabled={readOnly}
          />
        </FormField>
      </div>
      )}

      {/* Fila 4: Cargo - Área */}
      <div className="form-row">
        <FormField label="Cargo" required={!createContactMode} error={errors?.position}>
          <Input
            value={data.position}
            onChange={(e) => handleChange('position', e.target.value)}
            onBlur={(e) => handleBlur('position', e.target.value)}
            placeholder="Ej: Director de Innovación"
            error={!!errors?.position}
            disabled={readOnly}
          />
        </FormField>
        <FormField label="Área" required={!createContactMode} error={errors?.area}>
          <SearchableSelect
            value={data.area || ''}
            onChange={handleAreaChange}
            options={areas}
            placeholder="Seleccionar área..."
            allowCustomInput={false}
            error={!!errors?.area}
            disabled={readOnly}
          />
        </FormField>
      </div>

      {/* Fila 5: Subárea - LinkedIn (modal crear contacto) o Subárea - Sitio web (perfil) */}
      <div className="form-row">
        <FormField label="Subárea" required={!createContactMode} error={errors?.subarea}>
          <SearchableSelect
            value={data.subarea || ''}
            onChange={(value) => handleChange('subarea', value)}
            options={subareasDinamicas}
            placeholder={data.area ? "Seleccionar subárea..." : "Primero selecciona el área"}
            allowCustomInput={false}
            disabled={readOnly || !data.area || subareasDinamicas.length === 0}
            error={!!errors?.subarea}
          />
        </FormField>
        {createContactMode ? (
          <FormField label="LinkedIn" error={errors?.linkedin}>
            <Input
              type="url"
              value={data.linkedin || ''}
              onChange={(e) => handleChange('linkedin', e.target.value)}
              placeholder="https://www.linkedin.com/in/..."
              error={!!errors?.linkedin}
              disabled={readOnly}
            />
          </FormField>
        ) : (
        <FormField label="Sitio web" required error={basicInfoErrors?.website || websiteError || undefined}>
          <Input
            type="url"
            value={basicInfo?.website || ''}
            onChange={handleWebsiteChange}
            onBlur={handleWebsiteBlur}
            placeholder="https://www.ejemplo.com"
            error={!!basicInfoErrors?.website || !!websiteError}
            disabled={readOnly}
          />
        </FormField>
        )}
      </div>

      {/* Fila 6: Industrias - oculta en modal crear contacto */}
      {!createContactMode && (
      <div className="form-row">
        <FormField label="Industrias" error={basicInfoErrors?.industries}>
          <MultiSelectTags
            selectedValues={basicInfo?.industries || []}
            onChange={(values) => handleBasicInfoChange('industries', values)}
            error={basicInfoErrors?.industries}
            disabled={readOnly}
          />
        </FormField>
        <div></div>
      </div>
      )}

      {/* Fila 7: Ejes de interés */}
      <FormField 
        label="Ejes de interés" 
        error={axesError}
        helpText={createContactMode ? undefined : (
          <>
            Selecciona uno o varios ejes temáticos (Conoce más de cada eje en{' '}
            <a 
              href="https://smartcityexposantiagodelestero.com/tematicas" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                color: '#CE2B15', 
                textDecoration: 'none',
                fontWeight: 600
              }}
              onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
              onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
            >
              Temáticas
            </a>
            )
          </>
        )}
      >
        <div className={`checkbox-group thematic-axes-two-columns ${axesError ? 'error' : ''}`}>
          {/* Selector "Seleccionar todos" */}
          <label 
            className="checkbox-item select-all-checkbox"
            style={{
              fontWeight: 600,
              marginBottom: '8px',
              width: '100%'
            }}
          >
            <input
              type="checkbox"
              checked={
                (data.thematicAxes || []).length > 0 &&
                (data.thematicAxes || []).length === thematicAxes.length
              }
              onChange={(e) => {
                if (readOnly) return;
                if (e.target.checked) {
                  // Seleccionar todos
                  const allAxes = thematicAxes.map(axis => axis.value);
                  onChange({ ...data, thematicAxes: allAxes });
                } else {
                  // Deseleccionar todos
                  onChange({ ...data, thematicAxes: [] });
                }
              }}
              disabled={readOnly}
            />
            <span className="checkbox-label">Seleccionar todos</span>
          </label>
          {thematicAxes.map((option, index) => {
            const subejes = subejesPorEje[option.label]?.subejes || [];
            const hasSubejes = subejes.length > 0;

            return (
              <label 
                key={option.value} 
                className={`checkbox-item ${hasSubejes ? 'has-tooltip' : ''}`}
                onMouseEnter={(e) => {
                  if (hasSubejes && !isMobileOrTablet) {
                    const rect = e.currentTarget.getBoundingClientRect();
                    const tooltipWidth = 300;
                    const spacing = 10;

                    let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
                    let top = rect.bottom + spacing;

                    if (left + tooltipWidth > window.innerWidth) {
                      left = window.innerWidth - tooltipWidth - 10;
                    }
                    if (left < 10) {
                      left = 10;
                    }

                    const tooltipHeight = 200;
                    if (top + tooltipHeight > window.innerHeight) {
                      top = rect.top - tooltipHeight - spacing;
                    }
                    if (top < 10) {
                      top = 10;
                    }

                    setVisibleTooltip(index);
                    setTooltipPosition({ left, top });
                  }
                }}
                onMouseLeave={() => {
                  if (!isMobileOrTablet) {
                    setVisibleTooltip(null);
                    setTooltipPosition(null);
                  }
                }}
              >
                <input
                  type="checkbox"
                  checked={(data.thematicAxes || []).includes(option.value)}
                  onChange={(e) => {
                    if (readOnly) return;
                    handleAxesChange(option.value, e.target.checked);
                  }}
                  disabled={readOnly}
                />
                <span className="checkbox-label">{option.label}</span>
                {hasSubejes && isMobileOrTablet && (
                  <span
                    className="modalidad-info-icon"
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      backgroundColor: '#f3f4f6',
                      color: '#6b7280',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      border: '1px solid #d1d5db',
                      flexShrink: 0,
                      transition: 'all 0.2s ease',
                      marginLeft: '8px',
                      display: 'flex'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();

                      if (visibleTooltip === index) {
                        setVisibleTooltip(null);
                        setTooltipPosition(null);
                        return;
                      }

                      const rect = e.currentTarget.getBoundingClientRect();
                      const tooltipWidth = 300;
                      const spacing = 10;

                      let left = rect.left + (rect.width / 2) - (tooltipWidth / 2);
                      let top = rect.bottom + spacing;

                      if (left + tooltipWidth > window.innerWidth) {
                        left = window.innerWidth - tooltipWidth - 10;
                      }
                      if (left < 10) {
                        left = 10;
                      }

                      const tooltipHeight = 200;
                      if (top + tooltipHeight > window.innerHeight) {
                        top = rect.top - tooltipHeight - spacing;
                      }
                      if (top < 10) {
                        top = 10;
                      }

                      setVisibleTooltip(index);
                      setTooltipPosition({ left, top });
                    }}
                  >
                    ?
                  </span>
                )}
              </label>
            );
          })}
        </div>
      </FormField>

      {/* En modal crear contacto no se muestra el checkbox de rondas de negocio */}
      {!createContactMode && (
      /* Checkboxes de administración y participación - fijos al pie cuando está en Perfil Personal */
      <div className="manage-profile-checkbox-fixed">
        <label>
          <input
            type="checkbox"
            checked={data.wantsToManageProfile || false}
            onChange={(e) => {
              if (readOnly) return;
              onChange({ ...data, wantsToManageProfile: e.target.checked });
            }}
            disabled={readOnly}
          />
          <span className="checkbox-label">Deseo administrar el perfil de mi organización</span>
        </label>
        <label>
          <input
            type="checkbox"
            checked={data.wantsToParticipateBusinessRounds || false}
            onChange={(e) => {
              if (readOnly) return;
              onChange({ ...data, wantsToParticipateBusinessRounds: e.target.checked });
            }}
            disabled={readOnly}
          />
          <span className="checkbox-label">
            Deseo participar en{' '}
            <a
              href="https://smartcityexposantiagodelestero.com/rondas-de-negocios"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#CE2B15',
                textDecoration: 'none',
                fontWeight: 600
              }}
              onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
              onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
            >
              Rondas de negocios
            </a>
            {' '}durante los días del evento
          </span>
        </label>
      </div>
      )}

    </FormSection>
    </div>
  );
};

export default ContactInfoSection;
